export default "__VITE_ASSET__CVz5pOcL__"